import { createStore } from '@/shared/lib/store';
import type { AttributeFilter } from '@/entities/dashboards';

/**
 * Выборка (scope), в контексте которой открыта карточка понятия.
 * Совпадает по смыслу со сквозным фильтром страницы раздела «Стратег» —
 * задаёт, из каких диалогов брать примеры реплик.
 */
export type ConceptCardScope = {
  /** Атрибутные фильтры выборки */
  filters: AttributeFilter[];
  /** Начало периода в формате YYYY-MM-DD */
  dateFrom?: string;
  /** Конец периода в формате YYYY-MM-DD */
  dateTo?: string;
};

/**
 * Состояние стора карточки понятия.
 */
type ConceptCardStore = {
  /** Открытое понятие (conceptId) либо null — карточка закрыта */
  conceptId: string | null;
  /** Выборка, в контексте которой открыта карточка, либо null */
  scope: ConceptCardScope | null;
  /** Открыть карточку понятия в контексте текущей выборки страницы */
  open: (conceptId: string, scope?: ConceptCardScope | null) => void;
  /** Закрыть карточку */
  close: () => void;
};

/**
 * Общий стор открытия единой «Карточки понятия» раздела «Стратег».
 *
 * Любой интерфейс раздела вызывает {@link ConceptCardStore.open} с `conceptId`
 * кликнутого понятия и текущей выборкой страницы (`scope`), а смонтированный на
 * странице `ConceptCardDrawer` подписан на стор и показывает карточку.
 */
export const useConceptCardStore = createStore<ConceptCardStore>('concept-card', (set) => ({
  conceptId: null,
  scope: null,
  open: (conceptId, scope) => set({ conceptId, scope: scope ?? null }),
  close: () => set({ conceptId: null }),
}));
